module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bold-webfont.74f174d0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-bold-webfont.woff
// module id = 280
// module chunks = 0